import { FaqCategoryDto } from '@feature/_app_modules/responsive-faq/faq.types';
import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';

/**
 * This services provides form for faq category editors
 */
 @Injectable({
    providedIn: 'root'
})

export class FaqCategoryFormsService {
    constructor(private formBuilder: FormBuilder) { }

    /**
     * Maps the values from a form to faq category
     * @param form The form to map to faq category
     * @param category The faq category whose values will be mapped from the form
     */
    mapFormToCategory(form: FormGroup, category: FaqCategoryDto){
        category.Title = form.controls['categoryName'].value;
    }

    /**
     * Maps the values of the faq category to the form
     * @param form The form whose values will be mapped from a faq category
     * @param category The faq category to map to form
     */
    mapCategoryToForm(form: FormGroup, category: FaqCategoryDto){
        form.controls['categoryName'].setValue(category.Title);
    }

    /**
     * Prepare a form group for a category
     * Currently the form used for the inline editor and the dialog are the same definition
     * hence they use this same method
     */
    buildForm(faqCategories: FaqCategoryDto[]){
        return this.formBuilder.group(
            {
                categoryName: new FormControl('', [Validators.required, this.categoryUnique(faqCategories)])
            });
    }

    /**
     * Validator for unique faq category
     * @param faqCategories 
     * @returns 
     */
    categoryUnique(faqCategories: FaqCategoryDto[]): ValidatorFn{
        return (control: AbstractControl): ValidationErrors | null => {
            return faqCategories?.length > 0 && faqCategories?.some(x => x.Title === control.value.trim())? { invalidcategory: control.value } : null;
          };
    }
}